var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('no-retoggle-collapse',_vm._g(_vm._b({staticClass:"step-accordion-shell"},'no-retoggle-collapse',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }